import { World } from '../ecs'; // Update this import
import { WorldGrid } from '../world/WorldGrid';
import { TERRAIN_TYPES } from '../../constants/terrain';

export function generateWorld(seed?: number): World {
  // Use the seed if provided
  const grid = new WorldGrid(100, 100, TERRAIN_TYPES[0]);
  // ... populate the grid with terrain

  const world = new World(grid);
  // ... add entities to the world

  return world;
}